import * as angular from 'angular';
import 'angular-ui-router';
import permissions from 'application/detail/permissions.json';
import BlipDeskView from './blipdesk/BlipDeskView.html';
import { BlipDeskController } from './blipdesk/BlipDeskController';
import SalesforceView from './salesforce/SalesforceView.html';
import { SalesforceController } from './salesforce/SalesforceController';
import WebhookView from './webhook/DeskWebhookView.html';
import { WebhookController } from './webhook/DeskWebhookController';
export const BLIPDESK_STATE = 'auth.application.detail.attendance.channels.blipdesk';
export const SALESFORCE_STATE = 'auth.application.detail.attendance.channels.salesforce';
export const WEBHOOK_STATE = 'auth.application.detail.attendance.channels.webhook';
export const channels = angular
    .module('attendance.channels', ['ui.router', 'shared'])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state(BLIPDESK_STATE, {
            url: '/blipdesk',
            views: {
                'content@auth.application.detail': {
                    template: BlipDeskView,
                    controller: BlipDeskController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        })
            .state(SALESFORCE_STATE, {
            url: '/salesforce',
            views: {
                'content@auth.application.detail': {
                    template: SalesforceView,
                    controller: SalesforceController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        })
            .state(WEBHOOK_STATE, {
            url: '/webhook',
            views: {
                'content@auth.application.detail': {
                    template: WebhookView,
                    controller: WebhookController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        });
    }]).name;
